import { Injectable } from '@angular/core';

var setting = require('../../appsettings.json');

@Injectable()
export class AppConfigService {
    private usingDevData: boolean;
    public adalConfig: adal.Config;
    public apiURL: string;
    public instrumentationKey: string;
    public storageServer: string;

    constructor() {
        this.usingDevData = window.location.hostname.toLowerCase() != 'nuportal.nucalgon.com' ? true : false;

        if (this.usingDevData) {
            this.adalConfig = {
                tenant: 'nucalgon.onmicrosoft.com',
                clientId: setting["clientId_dev"],
                cacheLocation: 'localStorage',
                redirectUri: window.location.origin,
            };

            this.instrumentationKey = setting["instrumentationKey_dev"];
            this.apiURL = setting["apiURL_dev"];
            this.storageServer = setting["storageServer_dev"];
        }
        else {
            this.adalConfig = {
                tenant: 'nucalgon.onmicrosoft.com',
                clientId: setting["clientId"],
                cacheLocation: 'localStorage',
                redirectUri: window.location.origin,
            };

            this.instrumentationKey = setting["instrumentationKey"];
            this.apiURL = setting["apiURL"];
            this.storageServer = setting["storageServer"];
        }
    }
}